export default function highlightFilter (text, search) {
  if (!search || !text) { return text }

  const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

  const regex = new RegExp(`(${escapedSearch})`, 'gi')

  return text.replace(regex, '<span class="highlighted">$1</span>')
}
